import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'

import './site_common'

import 'Components/refosumu/subsidies_index_by_prefecture/component'

import 'Components/refosumu/company_card/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/basics/breadcrumb/component'

import 'Components/refosumu/subsidies/go_to_top/component'
import 'Components/refosumu/subsidies/heading/component'
import 'Components/refosumu/subsidies/accordion_content_with_heading/component'
import 'Components/refosumu/subsidies/activities_section/component'
import 'Components/refosumu/subsidies/receiving_flow_section/component'
import 'Components/refosumu/subsidies/search_by_prefectures/component'
import 'Components/refosumu/subsidies/search_by_cities/component'
import 'Components/refosumu/subsidies/search_by_construction_parts/component'
import 'Components/refosumu/subsidies/summary_card/component'
import 'Components/refosumu/subsidies/search_result_view/component'
import 'Components/refosumu/subsidies/search_result_view_more_button/component'
import 'Components/refosumu/subsidies/search_panel/component'
import 'Components/refosumu/subsidies/fv_cta/component'
import 'Components/refosumu/shared/bookmark_list_link/component'
import 'Components/refosumu/v2/subsidies/floating_cta/pc/component'
import 'Components/refosumu/v2/subsidies/floating_cta/sp/component'
import 'Components/refosumu/subsidies/area_description/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'
import { setViewHeight } from '../../src/subsidies/components/setViewHeight'
import { changeCompleteStatusForSelect } from '../../src/subsidies/components/changeCompleteStatusForSelect'

window.$ = $

$(() => {
  // スマートフォンのハンバーガーメニュー処理
  spToggleNav()

  // スマホのメニューバーを考慮したvhを利用するために実行
  setViewHeight()
  window.addEventListener('resize', setViewHeight)

  // セレクトタグ用のプレースホルダー処理
  changeCompleteStatusForSelect()
})
